export enum PackageSource {
    Portal = 'Portal',
    Client = 'Client',
    Task = 'Task'
}
